var exports = {
  "p": "x804f0401--482c70--list",
};

module.exports = exports;
